// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7864e609","226":"27dc3ed9","537":"46c48120","749":"35e2c0ac","787":"0260d1fe","813":"2c137058","908":"f6335c2b"}[chunkId] + ".chunk.js";
};